import { render, staticRenderFns } from "./gatherUploadBtn.vue?vue&type=template&id=64619b07&scoped=true"
import script from "./gatherUploadBtn.vue?vue&type=script&lang=js"
export * from "./gatherUploadBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64619b07",
  null
  
)

export default component.exports